import React from "react";

export function CustomizationMessageBanner({ message, styles }) {
  if (!message.text) return null;

  return (
    <div
      style={{
        ...styles.message,
        backgroundColor:
          message.type === "success" ? "rgba(0, 212, 255, 0.2)" : "rgba(255, 107, 53, 0.2)",
        border:
          message.type === "success"
            ? "1px solid rgba(0, 212, 255, 0.5)"
            : "1px solid rgba(255, 107, 53, 0.5)",
        color: message.type === "success" ? "#00D4FF" : "#FF6B35",
      }}
    >
      {message.text}
    </div>
  );
}
